import React from 'react';
import styled, { css } from 'styled-components';
import { TableVariant } from '../types';
const Wrapper = styled.td `
  --button-padding-x-sm: 8px;

  position: sticky;
  right: 0;
  display: flex;
  align-items: center;
  background-color: ${({ theme, $isHeader, $variant }) => $isHeader && $variant === TableVariant.Grid
    ? theme.secondary.blendToBackground(25)
    : `var(--table-row-background-color, ${theme.background})`};
  z-index: 3;
  box-sizing: border-box;
  transition: background-color 0.2s;
  border-spacing: 0;
  ${({ $isHeader }) => $isHeader &&
    css `
      height: 100%;
    `}

  ${({ $isEmpty, $variant }) => $variant === TableVariant.Grid &&
    css `
      border-left: 1px solid ${({ theme }) => ($isEmpty ? 'transparent' : theme.secondary.blendToBackground(200))};
    `}
  ${({ $variant }) => $variant === TableVariant.List &&
    css `
      &:before {
        content: '';
        position: absolute;
        left: -12px;
        top: 0;
        bottom: 0;
        width: 12px;
        pointer-events: none;
        background-color: var(--table-row-background-color, ${({ theme }) => theme.background});
        transition: background-color 0.2s;
        mask-image: linear-gradient(to right, transparent 0px, rgba(0, 0, 0, 1) 16px, rgba(0, 0, 0, 1) 100%);
        -webkit-mask-image: linear-gradient(to right, transparent 0px, rgba(0, 0, 0, 1) 16px, rgba(0, 0, 0, 1) 100%);
        mask-repeat: no-repeat;
        -webkit-mask-repeat: no-repeat;
        mask-size: 100% 100%;
        -webkit-mask-size: 100% 100%;
      }
    `};
`;
const HeaderWrapper = styled(Wrapper).attrs({ as: 'th' }) ``;
const InnerWrapper = styled.div `
  ${({ $isHeader, $variant }) => $variant === TableVariant.Grid &&
    css `
      padding: ${$isHeader ? '0 4px' : '4px'};
    `}

  ${({ $variant }) => $variant === TableVariant.List &&
    css `
      padding: 0 12px;
    `}
`;
export const ActionCell = ({ isHeader, isEmpty, variant, children, }) => {
    const Component = isHeader ? HeaderWrapper : Wrapper;
    return (React.createElement(Component, { "$isEmpty": isEmpty, "$isHeader": isHeader, "$variant": variant, "data-role": isHeader ? 'header-action-cell' : 'body-action-cell' },
        React.createElement(InnerWrapper, { "$isHeader": isHeader, "$variant": variant }, children)));
};
//# sourceMappingURL=ActionCell.js.map